import React from 'react';
import { Button } from 'components/Button';
import LoitLogo from 'assets/icons/loit-logo.svg';
import { Container, BoxMaintenance, ContainerButton } from './styles';

const Maintenance = () => (
  <Container>
    <img src={LoitLogo} alt="logo maintenance" />
    <BoxMaintenance>
      <div>
        <h1>
          Olá! Estamos em manutenção.
        </h1>
        <h2>
          O portal da LOIT FGTS está temporariamente indisponível.
          {' '}
          <br />
          Estamos aplicando algumas melhorias em nosso sistema a fim de melhorá-lo para você e em breve retornaremos.
        </h2>
        <ContainerButton>
          <a
            href={process.env.REACT_APP_LOIT_URL}
            rel="noreferrer"
          >
            <Button>Retornar ao site</Button>
          </a>
        </ContainerButton>
      </div>
    </BoxMaintenance>
  </Container>
);

export default Maintenance;
